import {
  GET_INSIGHTS_FAILED,
  GET_INSIGHTS_STARTED,
  GET_INSIGHTS_SUCCESS,
  GET_ONE_TIME_GUEST_DATA_SUCCESS,
  GET_REPEAT_GUEST_DATA_SUCCESS
} from '../actions/actionTypes'

export default function insights(
  state = {
    loading: false,
    erred: false,
    repeatGuests: {
      last3yearsMonthly: null
    },
    otaPerformances: {
      last3yearsMonthly: null,
      last12months: null
    },
    directPerformances: {
      last3yearsMonthly: null,
      last12months: null
    },
    invitePerformances: null,
    reservationLengthInsights: {
      thisYear: null
    }
  },
  action
) {
  switch (action.type) {
    case GET_ONE_TIME_GUEST_DATA_SUCCESS:
      return {
        ...state,
        oneTimeGuests: action.payload,
        loading: false,
        erred: false
      }

    case GET_REPEAT_GUEST_DATA_SUCCESS:
      return {
        ...state,
        repeatGuests: action.payload,
        loading: false,
        erred: false
      }

    case GET_INSIGHTS_STARTED: {
      return {
        ...state,
        erred: false,
        loading: true
      }
    }

    case GET_INSIGHTS_SUCCESS:
      return {
        ...state,
        erred: false,
        otaPerformances: action.payload.otaPerformances,
        directPerformances: action.payload.directPerformances,
        invitePerformances: action.payload.invitePerformances,
        reservationLengthInsights: action.payload.reservationLengthInsights,
        loading: false
      }

    case GET_INSIGHTS_FAILED:
      return {
        ...state,
        loading: false,
        erred: true
      }

    default:
      return state
  }
}
